import React, { useCallback } from "react";
import styles from "./Tag.module.css";
import { VideoTag } from "../../video/models/VideoTag";

interface TagProps {
    tag?: VideoTag;
    contentTag?: string;
    onClick?: (tag: VideoTag) => void;
}

function Tag({ tag, contentTag, onClick }: TagProps) {
    const handleClick = useCallback(() => {
        if (onClick && tag) {
            onClick(tag);
        }
    }, [onClick, tag]);

    return (
        <div className={styles.tag} onClick={handleClick}>
            {tag && tag}
            {contentTag && contentTag}
        </div>
    );
}

export default Tag;
